angular.module('institutions')

    .controller("institutionsListCtrl", ['LoginService', '$rootScope', '$scope', 'Restangular', 'gridService', 'modalService', '$filter', '$state', 'logService',
        function (LoginService, $rootScope, $scope, Restangular, gridService, modalService, $filter, $state, logService) {

            $rootScope.title = $filter('translate')('institutions.title');
            logService.debug($filter('translate')('institutions.title'));
            $rootScope.breadcrumb = [
                { title: $filter('translate')('institutions.title') }
            ];

            $scope.allowWrite = LoginService.permissionExist("PERSONS_WRITE");

            $scope.gridOptions = {
                exporterMenuCsv: true,
                enableGridMenu: true,
                gridMenuShowHideColumns: false,
                enableSorting: true,
                paginationPageSizes: [20, 40, 60],
                paginationPageSize: 20,
                onRegisterApi: function (gridApi) {
                    this.gridApi = gridApi;
                },
                columnDefs: [
                    { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
                    {
                        name: 'icon', displayName: $filter('translate')('cms.icon'), cellTemplate: '<div class="ui-grid-cell-contents">' +
                            '<i class="fas fa-{{row.entity.icon}} text-primary m-l-sm" ></i>' +
                            '</div>', width: 80, enableFiltering: false, enableHiding: false
                    },
                    { name: 'name', displayName: $filter('translate')('general.name'), enableFiltering: true, enableHiding: false},
                    {
                        name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                            { title: $filter('translate')('general.button_edit'), action: 'ui-sref="institutions.edit({id:row.entity.id})"; ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-edit" },
                            { title: $filter('translate')('general.button_delete'), action: 'ng-click="grid.appScope.deleteDialog(row.entity.id,row.entity.title);" ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-remove" }
                        ], { cssClass: "pull-right" })
                    },
                ],
                getData: function (options) {
                    logService.debug('Que está pasando')
                    return Restangular.all('Institutions').getList(options).then(function (result) {
                        return result;
                    })
                }
            };


            $scope.goToEdit = function (rowEntity) {
                $state.go("institutions.edit", { id: rowEntity.id });
            };


            $scope.deleteDialog = function (id, title) {

                modalService.confirm({
                    title: $filter('translate')('general.delete'),
                    message: $filter('translate')('institutions.delete_message'),
                    onAccept: function () {
                        Restangular.one('Institutions', $scope.id).remove().then(function () {
                            toastr.success($filter('translate')('institutions.deleted_success'));
                            $scope.gridOptions.gridApi.core.raise.itemDeleted($scope);

                        }, function (response) {
                            $scope.errorMessage = response.message;
                        });
                    }
                });


            }
        }])